import { render, staticRenderFns } from "./DialogShioRequest.vue?vue&type=template&id=faa782e8&"
import script from "./DialogShioRequest.vue?vue&type=script&lang=js&"
export * from "./DialogShioRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports